import Vue from 'vue'
Vue.directive('pointer',{
    bind:function (el,binding,vnode) {
        el.style.cursor='pointer';
    }
})